<div *ngIf="showDirectAreas" class="inner-sub wow fadeInUp" data-wow-duration="1.5s">
  <div class="sub container">

      <div class="left">
          © onLygal {{getYear()}} - v{{version}}
      </div>

      

      <div class="right">
          <ul>
              <li *ngFor="let item of sub">
                  <a [routerLink]="resolveRouterLink(item.url)">{{item.title}}</a>
              </li>
          </ul>
      </div>
  </div>
</div>

<div *ngIf="!showDirectAreas" class="inner-sub wow fadeInUp" data-wow-duration="1.5s"  style="margin-top: 15vh">
  <div class="sub container">

      <div class="left">
          © Grupo onLygal {{getYear()}} - v{{version}}
      </div>

      

      <div class="right">
          <ul>
              <li *ngFor="let item of sub">
                  <a [routerLink]="resolveRouterLink(item.url)">{{item.title}}</a>
              </li>
          </ul>
      </div>
  </div>
</div>

